import styled from 'styled-components';

const OptionContainer = styled.span`
  width: fit-content;
`;

export {
  OptionContainer,
};
